<template>
  <div class="logos flex wrap gap-1 justify-center">
    <PaymentLogo v-for="logo in $branch.paymentLogos" :logo class="logo" />
  </div>
</template>

<style scoped>
.logo {
  height: 32px;
  width: unset;
}
</style>